exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".how-to-video-ok-ih {\n  background-color: #217106;\n}\n.how-to-video-ok-ih:hover {\n  background-color: #217106 !important;\n}\n.how-to-video-ok-normal {\n  background-color: #0065A1;\n}\n.how-to-video-ok-normal:hover {\n  background-color: #004d7b !important;\n}\n", ""]);

